import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacrystaonrentpinpune() {



const cardData = {
  keyword: " Innova Crysta On Rent in Pune  ",

"headingDescription": "Innova Crysta On Rent in Pune offers premium, comfortable, and spacious travel solutions for families, corporate clients, and group trips. SRS Cab Service provides well-maintained Innova Crysta vehicles with professional drivers to ensure a smooth, safe, and enjoyable ride across Pune. Whether it’s city sightseeing, airport transfers, or weekend getaways, our rental service delivers flexible booking, transparent fares, and 24/7 customer support, making your travel experience seamless and stress-free.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is an iconic historic fort in Pune, showcasing Maratha architecture. Travelers renting an Innova Crysta often include this landmark to explore Pune’s rich history and capture memorable photographs."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a significant historical monument tied to India’s freedom struggle. Visitors using Innova Crysta on rent often stop here to enjoy its tranquil gardens and informative museum exhibits."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is renowned for its panoramic views and trekking trails. Travelers renting an Innova Crysta frequently plan a visit for adventure, sightseeing, and nature photography."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most popular religious sites. Visitors using Innova Crysta on rent often stop here to experience spiritual calm and local devotional traditions."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine dedicated to Lord Shiva. Travelers renting an Innova Crysta enjoy its historic significance and peaceful environment."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses a diverse collection of Indian artifacts. Visitors using Innova Crysta explore Pune’s cultural and artistic heritage through sculptures, instruments, and decorative items."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple offers stunning views of Pune along with historic temples. Travelers renting an Innova Crysta often climb the hill for sightseeing and serene experiences."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a peaceful destination ideal for relaxation and photography. Groups renting Innova Crysta often include this scenic spot in their Pune itinerary."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden is a Japanese-style landscaped park perfect for a calm walk. Travelers using Innova Crysta on rent enjoy the lush greenery and serene environment."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic palace linked to Chhatrapati Shivaji Maharaj. Visitors renting an Innova Crysta often explore this landmark to understand Pune’s rich heritage."
  }
],



services: [
{
name: "Innova on Rent Pune",
description: "Innova on rent Pune offers comfortable travel for family and group trips. Customers can book spacious vehicles for local and outstation travel. Professional drivers ensure safe journeys. Comfortable seating enhances travel experience. Flexible booking options are available. Travel easily with Innova rentals in Pune."
},
{
name: "Innova Crysta Rental Pune",
description: "Innova Crysta rental Pune provides premium SUV travel with luxury features. Customers can enjoy spacious seating and smooth rides. Professional drivers ensure safe journeys. Ideal for corporate and family travel. Flexible booking options are available. Travel comfortably with Innova Crysta rentals."
},
{
name: "Innova Car Hire in Pune",
description: "Innova car hire in Pune offers reliable transportation for all travel needs. Customers can hire vehicles for city and outstation trips. Professional drivers ensure safe journeys. Comfortable interiors enhance experience. Flexible booking options are available. Hire Innova cars easily in Pune."
},
{
name: "Innova Car Rental in Pune",
description: "Innova car rental in Pune provides flexible vehicle options for travelers. Customers can book cars for personal and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Rent Innova cars easily in Pune."
},
{
name: "Innova Crysta on Rent Pune",
description: "Innova Crysta on rent Pune offers premium travel for long-distance journeys. Customers can enjoy spacious and comfortable rides. Professional drivers ensure safe travel. Ideal for family and corporate use. Flexible booking options are available. Travel easily with Innova Crysta services."
},
{
name: "Innova Crysta Rent in Pune",
description: "Innova Crysta rent in Pune provides luxury travel with modern features. Customers can book vehicles for tours and airport transfers. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Transparent pricing ensures affordability. Rent Innova Crysta cars easily in Pune."
},
{
name: "Pune Innova Rental",
description: "Pune Innova rental offers convenient transportation for city and outstation trips. Customers can book vehicles for flexible travel plans. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Innova rentals in Pune."
},
{
name: "Pune Mumbai Innova Rental",
description: "Pune Mumbai Innova rental provides reliable intercity travel between two major cities. Customers can book vehicles for business and leisure trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Innova rentals."
},
{
name: "Pune to Bhimashankar Innova Crysta",
description: "Pune to Bhimashankar Innova Crysta offers comfortable travel for pilgrimage trips. Customers can visit temples with ease. Professional drivers ensure safe ghat road journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with Innova Crysta services."
},
{
name: "Pune to Shirdi Innova Crysta on Rent",
description: "Pune to Shirdi Innova Crysta on rent provides convenient travel for temple visits. Customers can enjoy comfortable long-distance journeys. Professional drivers ensure safe travel. Spacious seating enhances experience. Flexible booking options are available. Travel easily with Innova Crysta to Shirdi."
},
{
name: "Pune to Mahabaleshwar Innova Cab",
description: "Pune to Mahabaleshwar Innova cab offers comfortable travel for hill station trips. Customers can enjoy scenic journeys. Professional drivers ensure safe travel on ghat roads. Spacious seating enhances experience. Flexible booking options are available. Travel easily to Mahabaleshwar with Innova."
},
{
name: "Pune to Mumbai International Airport Innova Crysta on Rent",
description: "Pune to Mumbai International Airport Innova Crysta on rent offers premium airport transfers. Customers can book vehicles for group travel. Professional drivers ensure timely journeys. Spacious seating and luggage space enhance experience. Flexible booking options are available. Travel easily to Mumbai Airport with Innova."
},
{
name: "Pune to Nashik Innova Crysta on Rent",
description: "Pune to Nashik Innova Crysta on rent provides comfortable travel for religious and leisure trips. Customers can book vehicles for group travel. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily to Nashik with Innova Crysta."
},
{
name: "Pune Airport Innova Crysta on Rent",
description: "Pune Airport Innova Crysta on rent offers premium travel for airport transfers. Customers can book vehicles for pickups and drops. Professional drivers ensure timely journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with airport Innova Crysta services."
},
{
name: "Pune to Shirdi and Shani Shingnapur Innova Cab",
description: "Pune to Shirdi and Shani Shingnapur Innova cab offers complete pilgrimage travel. Customers can visit multiple temples comfortably. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with Innova cab packages."
},
{
name: "Pune to Goa Innova Cab on Rent",
description: "Pune to Goa Innova cab on rent offers comfortable long-distance travel for vacations. Customers can enjoy spacious rides for beach trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Goa with Innova."
}
],

tableData: [
["Innova on Rent Pune","Innova Crysta Rental Pune"],
["Innova Car Hire in Pune","Innova Car Rental in Pune"],
["Innova Crysta on Rent Pune","Innova Crysta Rent in Pune"],
["Pune Innova Rental","Pune Mumbai Innova Rental"],
["Pune to Bhimashankar Innova Crysta","Pune to Shirdi Innova Crysta on Rent"],
["Pune to Mahabaleshwar Innova Cab","Pune to Mumbai International Airport Innova Crysta on Rent"],
["Pune to Nashik Innova Crysta on Rent","Pune Airport Innova Crysta on Rent"],
["Pune to Shirdi and Shani Shingnapur Innova Cab","Pune to Goa Innova Cab on Rent"]
],



whychoose: [
  {
    WhyChooseheading: "Premium & Comfortable SUV Travel",
    WhyChoosedescription: "SRS Cab Service offers Innova Crysta on rent in Pune, known for its spacious seating, smooth ride quality, and premium comfort, making it ideal for family and corporate travel."
  },
  {
    WhyChooseheading: "Affordable Innova Crysta Rental Pricing",
    WhyChoosedescription: "We provide budget-friendly Innova Crysta rental in Pune with transparent pricing. Rates typically start from ₹16 to ₹20 per km depending on trip type and duration. :contentReference[oaicite:0]{index=0}"
  },
  {
    WhyChooseheading: "Best for Outstation & Airport Travel",
    WhyChoosedescription: "Innova Crysta is perfect for Pune to Mumbai, Shirdi, Nashik, Goa, and airport transfers, offering smooth and reliable long-distance travel experience."
  },
  {
    WhyChooseheading: "24/7 Innova Cab Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Innova Crysta bookings in Pune, making it convenient for early morning, late-night, and emergency travel."
  },
  {
    WhyChooseheading: "Spacious 6+1 & 7+1 Seating Options",
    WhyChoosedescription: "Choose from 6+1 or 7+1 seater Innova Crysta options with ample legroom, luggage space, and comfortable seating for families and small groups."
  },
  {
    WhyChooseheading: "Professional Drivers for Safe Travel",
    WhyChoosedescription: "We provide trained and experienced drivers familiar with Pune city routes, highways, and outstation travel, ensuring safe and smooth journeys."
  },
  {
    WhyChooseheading: "Clean, AC & Well-Maintained Vehicles",
    WhyChoosedescription: "All Innova Crysta vehicles are fully air-conditioned, regularly cleaned, and maintained to deliver a comfortable and hygienic travel experience."
  },
  {
    WhyChooseheading: "Trusted Innova Rental Service in Pune",
    WhyChoosedescription: "SRS Cab Service is trusted for Innova Crysta on rent in Pune due to reliable service, affordable pricing, and customer satisfaction."
  }
]
}

const faqData = [
  { question: "Do you provide Innova Crysta on rent in Pune?", answer: "Yes, SRS Cab Service offers Innova Crysta rental in Pune for local, airport, and outstation travel." },
  { question: "What is the price of Innova Crysta per km in Pune?", answer: "The Innova Crysta rental price in Pune typically starts from ₹16 to ₹20 per km depending on the trip and vehicle type." },
  { question: "Is Innova Crysta available for outstation trips?", answer: "Yes, Innova Crysta is widely used for outstation travel like Mumbai, Shirdi, Nashik, Goa, and more." },
  { question: "How many passengers can travel in Innova Crysta?", answer: "Innova Crysta is available in 6+1 and 7+1 seating options, suitable for families and small groups." },
  { question: "Is Innova Crysta suitable for airport transfer?", answer: "Yes, Innova Crysta is ideal for Pune Airport and Mumbai Airport transfers with luggage space." },
  { question: "Is Innova Crysta available 24/7?", answer: "Yes, our service operates 24 hours a day for flexible booking." },
  { question: "Are Innova vehicles air-conditioned?", answer: "Yes, all Innova Crysta vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book Innova Crysta online?", answer: "Yes, you can easily book Innova Crysta on rent in Pune online or via phone." },
  { question: "Do you provide one-way cab service?", answer: "Yes, we provide one-way and round-trip Innova cab services." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Jadhav",
    feedback:
      "Booked Innova Crysta from SRS Cab Service for Mumbai trip. Very comfortable and premium experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Kulkarni",
    feedback:
      "Best Innova Crysta rental in Pune. Clean car, smooth ride, and professional driver.",
    rating: 5
  }
];
































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta On Rent in Pune | SRS Cab",
  "description": "SRS Cab offers Innova Crysta on rent in Pune for outstation trips, airport transfers, corporate travel, family tours, and temple visits. Book Innova Crysta for Pune to Shirdi, Pune to Mahabaleshwar, Pune to Mumbai Airport, Pune to Nashik, Pune to Goa, and other destinations with 24x7 online booking and affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Innova Crysta On Rent in Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Hire Innova Crysta on rent in Pune with SRS Cab. Perfect for outstation trips, airport transfers, corporate travel, family tours, and temple visits. Book online for Pune to Shirdi, Mahabaleshwar, Mumbai Airport, Nashik, Goa, and more. Affordable fares with 24x7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/31.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacrystaonrentpinpune;